<div [ngSwitch]="questionForm2.value?.type?.id">
  <div *ngSwitchCase="eQuestionType.Multi">
    <que-mark-question [formControl]="questionForm2" [index]="index"></que-mark-question>
  </div>
  <div *ngSwitchCase="eQuestionType.Autocomplete">
    <que-mark-question [formControl]="questionForm2" [index]="index"></que-mark-question>
  </div>
  <div *ngSwitchCase="eQuestionType.Mark">
    <que-mark-question [formControl]="questionForm2" [index]="index"></que-mark-question>
  </div>
  <div *ngSwitchCase="eQuestionType.FreeText">
    <que-free-text-question [formControl]="questionForm2" [index]="index">
    </que-free-text-question>
  </div>
  <div *ngSwitchCase="eQuestionType.Fill">
   <que-fill-question-display></que-fill-question-display>
  </div>
  <div *ngSwitchCase="eQuestionType.Number">
    <!-- <que-number-question></que-number-question> -->
  </div>
  <div *ngSwitchCase="eQuestionType.Table">
    <que-table-question [formControl]="questionForm2"
        [index]="index"></que-table-question>
  </div>
  <div *ngSwitchCase="eQuestionType.PhoneNumber">
    <que-phone-number-question-display>
      </que-phone-number-question-display>
  </div>
  <div *ngSwitchCase="eQuestionType.Range">
    <que-range-question [formControl]="questionForm2"
        [index]="index"></que-range-question>
  </div>
  <div *ngSwitchCase="eQuestionType.Link">
    <que-link [formControl]="questionForm2" [index]="index"></que-link>
  </div>
  <div *ngSwitchCase="eQuestionType.UploadFile">
    <que-upload-file [formControl]="questionForm2" [index]="index"></que-upload-file>
  </div>
  <div *ngSwitchCase="eQuestionType.UploadFileAdmin">
    <que-upload-file-admin [formControl]="questionForm2" [index]="index"></que-upload-file-admin>
  </div>
  <div *ngSwitchCase="eQuestionType.Date">
    <que-date-question [formControl]="questionForm2"></que-date-question>
  </div>
  <div *ngSwitchCase="eQuestionType.Text">
    <que-text-to-question [formControl]="questionForm2" [index]="index">
    </que-text-to-question>
  </div>
  <div *ngSwitchCase="eQuestionType.QuestionsGroup">
    <que-questions-group [formControl]="questionForm2" [index]="index">
      </que-questions-group>
  </div>
  <div *ngSwitchCase="eQuestionType.Signature">
    <que-signature [formControl]="questionForm2"></que-signature>
  </div>
  <div *ngSwitchCase="eQuestionType.Image">
    <que-image  [formControl]="questionForm2" ></que-image>
    <!-- <que-signature [type]="questionForm2.value?.type" [index]="index"></que-signature> -->
  </div>
    <div *ngSwitchCase="eQuestionType.Expense">
    <que-expense  [formControl]="questionForm2" ></que-expense>
  </div>
</div>